import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';


const namespaced: boolean = true;

export const state = {
    init: false,
    id: "",
    roleid:"",
    username: "",
    companyname: "",
    partyorgname: "",
    isadmin: false,
    user : {},
    rolename: "",
    roleInfo: ""
};

export const profileModule: Module<any, any> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};